import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'Accueil' },
  { path: '/aide-quotidienne', label: 'Aide à la vie quotidienne' },
  { path: '/conciergerie', label: 'Conciergerie' },
  { path: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-[90] bg-background-50/95 backdrop-blur-sm border-b border-background-200/60">
      <div className="relative flex items-center justify-between px-6 py-4 md:pl-4 md:pr-10">
        <Link to="/" onClick={() => setIsOpen(false)} className="flex items-center gap-2 group">
          <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 38C16 38 8 28 8 18C8 12 11 6 16 6C21 6 24 12 24 18C24 28 16 38 16 38Z" stroke="oklch(var(--accent-500))" strokeWidth="1.5" fill="none" />
            <path d="M16 6C16 6 12 12 12 18" stroke="oklch(var(--accent-500))" strokeWidth="1" fill="none" />
            <path d="M16 6C16 6 20 12 20 18" stroke="oklch(var(--accent-500))" strokeWidth="1" fill="none" />
            <circle cx="16" cy="14" r="2" fill="oklch(var(--accent-500))" />
          </svg>
          <div className="flex flex-col">
            <span className="font-heading font-bold text-sm md:text-base tracking-widest text-foreground-950 uppercase">Proximité Confiance</span>
            <span className="font-heading font-bold text-xs tracking-widest text-accent-500 uppercase">— Finistère —</span>
          </div>
        </Link>

        {/* Desktop horizontal menu - centered relative to the page */}
        <div className="hidden md:flex items-center gap-10 lg:gap-14 absolute left-1/2 -translate-x-1/2">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`relative font-heading text-lg lg:text-xl tracking-wide transition-colors duration-200 whitespace-nowrap pb-1 ${
                  isActive
                    ? 'text-primary-500'
                    : 'text-foreground-950 hover:text-primary-500'
                }`}
              >
                {link.label}
                {isActive && (
                  <span className="absolute left-0 right-0 bottom-0 h-px bg-primary-500 rounded-full" />
                )}
              </Link>
            );
          })}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex flex-col gap-1.5 p-2 cursor-pointer md:hidden"
          aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        >
          <span className={`block w-6 h-0.5 bg-foreground-950 transition-transform duration-300 origin-center ${isOpen ? 'rotate-45 translate-y-[9px]' : ''}`} />
          <span className={`block w-6 h-0.5 bg-foreground-950 transition-opacity duration-300 ${isOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-foreground-950 transition-transform duration-300 origin-center ${isOpen ? '-rotate-45 -translate-y-[9px]' : ''}`} />
        </button>
      </div>

      {/* Mobile dropdown */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out bg-background-50 ${
          isOpen ? 'max-h-96 border-t border-background-200/60' : 'max-h-0'
        }`}
      >
        <div className="flex flex-col py-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsOpen(false)}
              className={`font-heading text-lg tracking-wide px-8 py-3 transition-colors duration-200 ${
                location.pathname === link.path
                  ? 'text-primary-500'
                  : 'text-foreground-950 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}